export const ReportViewerConstant = {
    GroupRow: "GroupRow",
    DetailRow: "DetailRow",
    TotalRow: "TotalRow",
}


// WEBPACK FOOTER //
// ./src/app/modules/reports/shared/report-viewer/report-viewer.const.ts